import { FunctionComponent, PropsWithChildren, useMemo } from 'react';
import { CssBaseline, ThemeOptions } from '@mui/material';
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
  StyledEngineProvider,
} from '@mui/material/styles';
import palette from './palette';
import typography from './typography';
import { GlobalStyles } from './global-styles';

export const ThemeProvider: FunctionComponent<PropsWithChildren> = (props) => {
  const { children } = props;
  const themeOptions = useMemo<ThemeOptions>(
    () => ({
      components: {
        MuiCssBaseline: {
          styleOverrides: {
            body: {
              backgroundColor: palette.primary.darker,
            },
          },
        },
        MuiDrawer: {
          styleOverrides: {
            paper: {
              backgroundColor: palette.primary.dark,
            },
          },
        },
        MuiInputBase: {
          styleOverrides: {
            input: {
              backgroundColor: palette.primary.dark,
              borderRadius: '6px',
              color: 'white',
            },
            root: {
              backgroundColor: palette.primary.dark,
            },
          },
        },
        MuiList: {
          styleOverrides: {
            root: {
              ':before': { backgroundColor: palette.primary.dark },
            },
          },
        },
        MuiNativeSelect: {
          styleOverrides: {
            nativeInput: { backgroundColor: palette.primary.dark },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundColor: palette.primary.dark,
            },
          },
        },
        MuiTableCell: {
          styleOverrides: {
            root: {
              backgroundColor: palette.primary.dark,
            },
          },
        },
        MuiTablePagination: {
          styleOverrides: {
            menuItem: {
              backgroundColor: palette.primary.dark,
            },
            select: {
              backgroundColor: palette.primary.darker,
            },
          },
        },
        MuiToolbar: {
          styleOverrides: {
            root: {
              backgroundColor: palette.primary.dark,
            },
          },
        },
        MuiTypography: {
          styleOverrides: {
            root: {
              color: 'white',
            },
          },
        },
      },
      palette,
      shape: { borderRadius: 6 },
      typography,
    }),
    [],
  );

  const theme = createTheme(themeOptions);

  return (
    <StyledEngineProvider injectFirst>
      <MUIThemeProvider theme={theme}>
        <CssBaseline />
        <GlobalStyles />
        {children}
      </MUIThemeProvider>
    </StyledEngineProvider>
  );
};
